// extracted by mini-css-extract-plugin
module.exports = {"navigation":"header_navigation__E0Q_b"};